import { saveAs } from 'file-saver';
import { convertArrayToCSV } from 'convert-array-to-csv';
import JSZip from 'jszip';

export const LocalFilesService = {
  saveCsvFileAsZip: async (fileName, data) => {
    const csvData = convertArrayToCSV(data);

    const zip = new JSZip();
    zip.file(fileName + '.csv', csvData);

    const content = await zip.generateAsync({ type: 'blob' });

    saveAs(content, fileName + '.zip');
  },

  saveBlobToFile: (fileName, blob) => {
    const url = URL.createObjectURL(new Blob([blob]));

    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;

    document.body.appendChild(link);

    link.click();

    link.parentNode.removeChild(link);
    URL.revokeObjectURL(url);
  }
};
